import {
  GET_USER_WATCHER,
  LOGOUT_WATCHER,
  UPLOAD_LOGO_WATCHER,
} from "./constants"
import {
  SHOWED_FEEDBACK_SURVEY,
  KEY_ACTIVE_ROL,
  KEY_ANONYMITY,
  KEY_ANONYMITY_LEADERS,
  KEY_COMPANY_LOGO,
  KEY_COMPANY_NAME,
  KEY_FIRST_NAME,
  KEY_LAST_NAME,
  KEY_SECOND_LAST_NAME,
  LOCAL_COMPANY_ID,
  LOCAL_TOKEN,
  LOCAL_COMPANY_SUPPORT_CHANNEL,
  clearStorage,
  setItem,
} from "../../utils/storage"
import { call, put, takeLatest } from "redux-saga/effects"
import { getUserFailed, getUserSuccess, getUserWatcher } from "./actions"

import axios from "axios"
import { push } from "connected-react-router"
import { resetExpandedRows } from "../Division/actions"
import { isNotFromIframe, validate } from "../../utils/functions"
import { setLanguage } from "../../utils/i18n"
import { SUPPORT_CHANNELS, ROLE_COMPANY_SUPER_ADMIN, ROLE_COMPANY_ADMIN, ROLE_MANDU_SUPER_ADMIN, ROLE_MANDU_ADMIN } from "../../utils/constants"

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function getUserApi() {
  return axios.request({
    method: "get",
    url: `${process.env.API_URL}oauth/user`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
  })
}

function logoutApi() {
  return axios.request({
    method: "get",
    url: `${process.env.API_URL}oauth/logout`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
  })
}

// Individual exports for testing
export function* getUserSaga() {
  try {
    const {
      data: { data },
    } = yield call(getUserApi)

    setItem(SHOWED_FEEDBACK_SURVEY, data.showed_feedback_survey)
    setItem(KEY_ACTIVE_ROL, data.active_role)
    setItem(KEY_FIRST_NAME, data.first_name)
    setItem(KEY_LAST_NAME, data.last_name)
    setItem(KEY_SECOND_LAST_NAME, data.second_last_name)
    setLanguage(data.locale)

    if(isNotFromIframe()){ 
      // Solo inicializar chat para roles ADMINISTRADOR y SUPER ADMINISTRADOR
      const isAdmin = [
        ROLE_COMPANY_SUPER_ADMIN, 
        ROLE_COMPANY_ADMIN, 
        ROLE_MANDU_SUPER_ADMIN,
        ROLE_MANDU_ADMIN
      ].includes(data.active_role)

      if (isAdmin && 
          !window.location.pathname.includes("/companies") &&
          !window.location.pathname.includes("/users") &&
          !window.location.pathname.includes("/my-account")
      ) {
        const supportChannel = LOCAL_COMPANY_SUPPORT_CHANNEL()
        // PE = Perú, AR = Argentina, cualquier otro valor usa DEFAULT
        const appId = SUPPORT_CHANNELS[supportChannel] || SUPPORT_CHANNELS.DEFAULT
        console.log(appId)

        initializeChatWidget({
          id: data.id,
          name: `${data.first_name} ${data.last_name}`,
          email: data.email,
          createdAt: Date.now(),
          app_id: appId
        });
      }
    }

    yield put(getUserSuccess(data))
  } catch (error) {
    yield put(getUserFailed())
    removeLocalData()
    // ANCHOR: Redirect Login
    yield put(push("/login"))
  }
}

export function* logoutSaga() {
  try {
    /*
    if (typeof window.Intercom !== 'undefined'){
      
      window.fcWidget.user.clear();
      window.fcWidget.destroy(); // 
    }
    */
    yield put(push("/login"))
    yield call(logoutApi)
    //clearStorage()
    yield put(resetExpandedRows())
    // removeLocalData()


    // ANCHOR: Redirect Login

  } catch (e) {}
}

export function* logoutWatcher() {
  yield takeLatest(LOGOUT_WATCHER, logoutSaga)
}

export function* uploadLogoSaga(action) {
  try {
    const {
      data: {
        data,
        data: {
          result: { company },
        },
      },
    } = yield call(fetchGlobalApi, {
      method: "POST",
      endpoint: `companies/${LOCAL_COMPANY_ID()}/upload`,
      data: action.payload,
    })

    yield put(getUserWatcher())
  } catch (e) {}
}

function removeLocalData() {
  clearStorage()
}

export default function* userHeaderBoxSaga() {
  yield takeLatest(GET_USER_WATCHER, getUserSaga)
  yield takeLatest(LOGOUT_WATCHER, logoutSaga)
  yield takeLatest(UPLOAD_LOGO_WATCHER, uploadLogoSaga)
}
